import { render } from "./Telehealth.vue?vue&type=template&id=81d0e2da&scoped=true"
import script from "./Telehealth.vue?vue&type=script&lang=js"
export * from "./Telehealth.vue?vue&type=script&lang=js"

import "./Telehealth.vue?vue&type=style&index=0&id=81d0e2da&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d0e2da"]])

export default __exports__